<template lang="pug">
.bg-ro.fixed-top
  .container
    nav.navbar.navbar-expand-lg.navbar-dark.bg-ro
      a.navbar-brand.d-lg-none(href="#")
        img.img-fluid(
          src="http://res.99ro.top/web-assets/img/logo.png",
          alt="",
          srcset="",
          width="100px"
        )
      button.navbar-toggler.border-white(
        type="button",
        data-toggle="collapse",
        data-target="#navbarSupportedContent",
        aria-controls="navbarSupportedContent",
        aria-expanded="false",
        aria-label="Toggle navigation"
      )
        span.navbar-toggler-icon
      #navbarSupportedContent.collapse.navbar-collapse
        ul.navbar-nav.ml-auto
          li.nav-item
            router-link.nav-link.font-weight-bold.p-5(:to="{ name: 'Index' }")
              font-awesome-icon(
                :icon="['fas', 'home']",
                style="padding-right:10px;"
              )
              | 首页
              span.sr-only (current)
          li.nav-item
            a.nav-link.font-weight-bold.p-5(href="http://bbs.99ro.top/")
              font-awesome-icon(
                :icon="['fas', 'clipboard-list']",
                style="padding-right:10px;"
              )
              | 论坛攻略
          li.nav-item
            router-link.nav-link.font-weight-bold.p-5(
              :to="{ name: 'Account' }"
            )
              font-awesome-icon(
                :icon="['fas', 'user-tie']",
                style="padding-right:10px;"
              )
              | 账号注册
      //- a.navbar-brand.d-none.d-lg-block(href="#")
      //-   img.img-fluid(
      //-     src="http://res.99ro.top/web-assets/img/logo.png",
      //-     alt="",
      //-     srcset="",
      //-     width="100px"
      //-   )
      #navbarSupportedContent.collapse.navbar-collapse
        ul.navbar-nav.mr-auto
          li.nav-item
            router-link.nav-link.font-weight-bold.p-5(
              :to="{ name: 'Products', params: { data: '全部商品' } }"
            )
              font-awesome-icon(
                :icon="['fab', 'product-hunt']",
                style="padding-right:10px;"
              )
              | 全部商品
          li.nav-item
            router-link.nav-link.font-weight-bold.p-5(
              :to="{ name: 'Download' }"
            )
              font-awesome-icon(
                :icon="['fas', 'gamepad']",
                style="padding-right:10px;"
              )
              | 游戏下载
          li.nav-item
            router-link.nav-link.font-weight-bold.p-5(
              :to="{ name: 'Payment' }"
            )
              font-awesome-icon(
                :icon="['fas', 'coins']",
                style="padding-right:10px;"
              )
              | 赞助购买
</template>

<style lang="scss">
.fixed-top {
  z-index: 998 !important;
}
</style>

<script>
/* global $ */
export default {
  data() {
    return {
    };
  },
  methods: {
    navbarToggler() {
      $('.navbar a').on('click', () => {
        $('.navbar-toggler').click();
      });
    },
  },
  mounted() {
    this.navbarToggler();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue